<kal-table [dataSource]="ruleList" [columns]="columns" [displayedColumns]="displayedColumns" class="no-action">

    <tr *kalHeaderRowDef kal-header-row></tr>

    <td *kalBodyCell="'IdOperateur' let row">
        {{ (row.IdOperateur | findInListById: operatorList)?.Libelle }}
    </td>

    <td *kalBodyCell="'ParentheseOuvrante' let row">
        {{'(' | repeatString: row.ParentheseOuvrante}}
    </td>

    <td *kalBodyCell="'IdCritere' let row">
        <ng-container *ngIf="row.IdCritere | findInListById: criteriaList as criterion">

        <a class="gup-U-color--400 gup-O-link" (click)="openParametersDialog(criterion.Libelle , row.Parametres)" *ngIf="row.Parametres | arrayNotEmpty; else criterionLabel">
            <ng-container *ngTemplateOutlet="criterionLabel"></ng-container>
        </a>
        <ng-template #criterionLabel>
            {{ criterion?.Libelle }}
        </ng-template>
        </ng-container>
    </td>

    <td *kalBodyCell="'Valeur' let row">
        <ng-container *ngIf="!!row.ListeCalculs; else criterionValueTemplate">
            <ng-container *ngTemplateOutlet="advancedComputingLinkTemplate; context: {list: row.ListeCalculs, label: 'pour la valeur du critere &quot;'+  ((row.IdCritere | findInListById: criteriaList)?.Libelle) +' &quot;'}"></ng-container>
        </ng-container>
        <ng-template #criterionValueTemplate>
            <app-shared-advanced-rule-criterion-value-detail [value]="row.Valeur" [criterion]="row.IdCritere | findCriterionById: criteriaList"></app-shared-advanced-rule-criterion-value-detail>
        </ng-template>
    </td>

    <td *kalBodyCell="'Subvention' let row">
        <ng-container
            *ngTemplateOutlet="valueOrAdvancedComputingLink; context: {value: row.Subvention, list: row.ListeCalculsSubvention, label: 'pour la subvention'}"></ng-container>
    </td>

    <td *kalBodyCell="'SubventionDefaut' let row">
        <ng-container
            *ngTemplateOutlet="valueOrAdvancedComputingLink; context: {value: row.SubventionDefaut, list: row.ListeCalculsSubventionDefaut, label: 'pour la subvention par défaut'}"></ng-container>
    </td>

    <td *kalBodyCell="'SubventionGroupe' let row">
        <ng-container
            *ngTemplateOutlet="valueOrAdvancedComputingLink; context: {value: row.SubventionGroupe, list: row.ListeCalculsSubventionGroupe, label: 'pour la subvention pour la subvention du groupe'}"></ng-container>
    </td>

    <td *kalBodyCell="'SubventionDefautGroupe' let row">
        <ng-container
            *ngTemplateOutlet="valueOrAdvancedComputingLink; context: {value: row.SubventionDefautGroupe, list: row.ListeCalculsSubventionDefautGroupe, label: 'pour la subvention par défaut du groupe'}"></ng-container>
    </td>


    <td *kalBodyCell="'IdOperateurMolecule' let row">
        {{ (row.IdOperateurMolecule | findInListById: operatorList)?.Libelle }}
    </td>

    <td *kalBodyCell="'ParentheseFermante' let row">
        {{')' | repeatString: row.ParentheseFermante}}
    </td>

    <td *kalBodyCell="'IdRegleApplication' let row">
        {{ (row.IdRegleApplication | findInListById: applicationRuleList)?.Valeur }}
    </td>

    <td *kalBodyCell="'IdRegleNonApplication' let row">
        {{ (row.IdRegleNonApplication | findInListById: applicationRuleList)?.Valeur }}
    </td>

    <td *kalBodyCell="'IdTypeDate' let row">
        <ng-container *ngIf="(row.IdTypeDate | findInListById: dateTypeList) as dateType">
            {{ dateType?.Libelle }}
            <ng-container *ngIf="['SAI', 'SAIINF'].includes(dateType.Code)">({{row.Jours}} / {{row.Mois}})</ng-container>
        </ng-container>
    </td>

</kal-table>

<ng-template #valueOrAdvancedComputingLink let-value='value' let-list='list' let-label=label>

    <ng-container *ngIf="!!list; else valueTemplate">
        <ng-container *ngTemplateOutlet="advancedComputingLinkTemplate; context: {list, label}"></ng-container>
    </ng-container>

    <ng-template #valueTemplate>
        {{ isArticle ? value : (value | currency) }}
    </ng-template>

</ng-template>

<ng-template #advancedComputingLinkTemplate let-list="list" let-label="label">

    <a class="gup-U-color--400 gup-O-link" (click)="openAdvancedComputingDetail(label, list)">Calcul avancé</a>
</ng-template>

<ng-template #criterionParametersTemplate let-parameterList="parameterList">
    <app-shared-advanced-rule-criterion-parameters-detail [parameters]="parameterList"></app-shared-advanced-rule-criterion-parameters-detail>
</ng-template>
